// Single source of truth for Indian state/UT GST codes (used by every form with a stateCode).
export interface IndianState {
  code: string;
  name: string;
}

export const INDIAN_STATES: IndianState[] = [
  { code: '01', name: 'Jammu & Kashmir' },
  { code: '02', name: 'Himachal Pradesh' },
  { code: '03', name: 'Punjab' },
  { code: '04', name: 'Chandigarh' },
  { code: '05', name: 'Uttarakhand' },
  { code: '06', name: 'Haryana' },
  { code: '07', name: 'Delhi' },
  { code: '08', name: 'Rajasthan' },
  { code: '09', name: 'Uttar Pradesh' },
  { code: '10', name: 'Bihar' },
  { code: '11', name: 'Sikkim' },
  { code: '12', name: 'Arunachal Pradesh' },
  { code: '13', name: 'Nagaland' },
  { code: '14', name: 'Manipur' },
  { code: '15', name: 'Mizoram' },
  { code: '16', name: 'Tripura' },
  { code: '17', name: 'Meghalaya' },
  { code: '18', name: 'Assam' },
  { code: '19', name: 'West Bengal' },
  { code: '20', name: 'Jharkhand' },
  { code: '21', name: 'Odisha' },
  { code: '22', name: 'Chhattisgarh' },
  { code: '23', name: 'Madhya Pradesh' },
  { code: '24', name: 'Gujarat' },
  { code: '26', name: 'Dadra & Nagar Haveli and Daman & Diu' },
  { code: '27', name: 'Maharashtra' },
  { code: '29', name: 'Karnataka' },
  { code: '30', name: 'Goa' },
  { code: '31', name: 'Lakshadweep' },
  { code: '32', name: 'Kerala' },
  { code: '33', name: 'Tamil Nadu' },
  { code: '34', name: 'Puducherry' },
  { code: '35', name: 'Andaman & Nicobar Islands' },
  { code: '36', name: 'Telangana' },
  { code: '37', name: 'Andhra Pradesh' },
  { code: '38', name: 'Ladakh' },
];

// AntD Select options: "27 · Maharashtra".
export const STATE_OPTIONS = INDIAN_STATES.map((s) => ({ value: s.code, label: `${s.code} · ${s.name}` }));

/** Clean GST code → state name (no code prefix) — for display columns. */
export const STATE_NAME = new Map(INDIAN_STATES.map((s) => [s.code, s.name] as [string, string]));
export const stateName = (code?: string | null) => (code ? (STATE_NAME.get(code) ?? code) : '');

const norm = (s: string) => s.toLowerCase().replace(/[^a-z]/g, '');
const NAME_TO_CODE: Record<string, string> = (() => {
  const m: Record<string, string> = {};
  for (const s of INDIAN_STATES) m[norm(s.name)] = s.code;
  // Aliases for names OSM/Nominatim may return.
  m[norm('NCT of Delhi')] = '07';
  m[norm('National Capital Territory of Delhi')] = '07';
  m[norm('Orissa')] = '21';
  m[norm('Pondicherry')] = '34';
  m[norm('Uttaranchal')] = '05';
  return m;
})();

/** Best-effort map of a state NAME (e.g. from a geocoder) to its 2-digit GST code; undefined if unknown. */
export const stateCodeFromName = (name?: string | null): string | undefined =>
  name ? NAME_TO_CODE[norm(name)] : undefined;
